import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function VanillaFrappe() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Vanilla Frappé</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>Icy, frothy vanilla shaked drink — like a vanilla crème frappe with coffee</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/vanilla_frappe.svg" alt="Vanilla frappé — frothy iced vanilla drink" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 20px 0",
          maxWidth: 1200,
          margin: "0 auto",
          flexWrap: "wrap"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>1 cup milk (whole milk or a mix of milk and a splash of cream)</li>
              <li>1½ cups ice cubes</li>
              <li>1 and 1/2 tbsp brown sugar</li>
              <li>1/2 tsp vanilla syrup</li>
              <li>Whipped cream, for topping</li>
              <li>Pinch of salt (optional — brightens sweetness)</li>
              <li>1 and 1/2 tsp instant coffee powder</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Add vanilla syrup , sugar, and coffee powder to a small shaking jar.</li>
              <li>Shake the jar until the drink is thick and frothy and you lose it.</li>
              <li>Pour into a tall glass completely filled with ice and add milk. Stir in the contents of the jar until the drink is thick and frothy. Add whipped cream if you like.</li>
              <li>Serve right away with a wide straw or a spoon while it is still cold.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Use crushed ice instead of whole cubes for a thicker, café-style froth when shaking.</li>
              <li>Dissolve the sugar and coffee powder in a splash of hot water first if they won't fully mix cold.</li>
              <li>Shake hard for at least 30 seconds — that's what builds the frothy top layer.</li>
              <li>Skip the coffee for a pure vanilla frappé that kids will love too.</li>
              <li>Serve immediately; frappés separate quickly once they sit.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Milk contributes calcium and protein for strong bones and muscles.</li>
              <li>A moderate coffee kick can give a gentle energy and focus boost.</li>
              <li>Making it at home means you control the sugar, unlike many store-bought frappés.</li>
              <li>A cold treat that satisfies a sweet craving with far less sugar than a milkshake.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default VanillaFrappe;
